import { useSelector } from 'react-redux';
import { RootState } from 'store';

import { RoleVariantEnum } from 'common/graphql/types';

export function useIsClinicalTrialLeadUser(): boolean {
    const auth = useSelector((st: RootState) => st.auth);
    const roleId = auth?.activeUser?.roleVClaim?.sk;

    return roleId === RoleVariantEnum.ClinicalTrialLead;
}
